import styled, { css } from 'styled-components';

const setChildrenContainerHeight = (
  totalOfChilds: number,
  expanded: boolean,
  limitHeight: boolean,
) => {
  if (expanded) {
    return limitHeight
      ? 'max-height: 200px'
      : `max-height: calc(100vh + (${totalOfChilds} * 51px))`;
  }

  return 'max-height: 0px';
};

export const AccordionContent = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.splitcPalette.neutral[10]};
  padding: 14px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  justify-content: space-between;
  border-radius: 4px 4px 0 0;
`;

export const ChildContainer = styled.div<{
  expanded: boolean;
  limitHeight?: boolean;
  totalOfChilds: number;
}>`
  ${({ expanded, totalOfChilds, limitHeight = false, theme }) => css`
    visibility: ${expanded ? 'visible' : 'hidden'};
    ${setChildrenContainerHeight(totalOfChilds, expanded, limitHeight)};
    transition: all ${expanded ? '400ms' : '200ms'} cubic-bezier(0.87, 0, 0.13, 1);
    overflow: auto;
    border: 1px solid ${theme.palette.divider};
    border-radius: 0 0 4px 4px;
  `}
`;
export const Title = styled.span`
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
  overflow: hidden;
  background-color: transparent;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  color: ${({ theme }) => theme.splitcPalette.neutral[1]};
`;

export const IconButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.splitcPalette.neutral[5]};
  &:hover {
    background-color: ${({ theme }) => theme.splitcPalette.neutral[9]};
    border-radius: 6px;
  }
`;

export const AccordionLeftContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const AccordionContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 1px;
`;

export const AccordionItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  border-radius: 0 0 4px 4px;
`;

export const ActionContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 10px;
  background-color: ${({ theme }) => theme.splitcPalette.neutral[11]};
  border-color: ${({ theme }) => theme.palette.divider};
  border-style: solid;
  border-width: 0 1px 1px 1px;
  transition: all 0.2s;
  border-radius: 0 0 4px 4px;

  &:hover {
    background-color: ${({ theme }) => theme.splitcPalette.neutral[10]};
  }
`;
